import 'basscss/css/basscss.css'
import 'basscss-btn/css/btn.css'
import 'basscss-btn-primary/css/btn-primary.css'
import 'basscss-btn-outline/css/btn-outline.css'
import 'basscss-colors/css/colors.css'
import 'basscss-background-colors/css/background-colors.css'
import 'leaflet/dist/leaflet.css'
import 'animate.css/animate.css'
import 'bugsnag-js'

import './assets/main.css'

import * as React from 'react'
import * as ReactDOM from 'react-dom'

import * as packageData from '../package.json'
import App from './containers/App'
import PhotoPrerender from './components/Prerender/PhotoPrerender'
import { CRAWLER_USER_AGENTS } from './epics/constants'
import { matchPhotoRoute } from './states/RouterState'

Bugsnag.apiKey = process.env.REACT_APP_BUGSNAG_API_KEY!
Bugsnag.releaseStage = process.env.NODE_ENV!
Bugsnag.appVersion = (packageData as any).version

const prefix = '#mobileVer='
const mobileVersion = location.hash.startsWith(prefix)
  ? location.hash.substr(prefix.length)
  : undefined

// XXX: this is a hack, as PhantomJS is super dump, our app breaks it easily.
// to make it easier to render our app, we have a special component that's
// for PhantomJS request from prerender only
const photoMatch = matchPhotoRoute(window.location.pathname)
if (photoMatch && CRAWLER_USER_AGENTS.test(navigator.userAgent)) {
  ReactDOM.render(
    <PhotoPrerender id={photoMatch.params.id} />,
    document.getElementById('react-container')
  )
} else {
  ReactDOM.render(
    <App mobileVersion={mobileVersion} />,
    document.getElementById('react-container')
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx